// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".z31X5DGQWV78Qz7qT1sw{display:flex;flex-wrap:wrap;justify-content:center;gap:3px}._Pr1lfwvWkZh7OxuS2gi{min-width:120px;margin:4px}", "",{"version":3,"sources":["webpack://./src/lib/tools/jsdebugger/DebugButtons.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,cAAA,CACA,sBAAA,CACA,OAAA,CAGF,sBACE,eAAA,CACA,UAAA","sourcesContent":[".debugButtonsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 3px;\n}\n\n.debuggerButton {\n  min-width: 120px;\n  margin: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debugButtonsContainer": "z31X5DGQWV78Qz7qT1sw",
	"debuggerButton": "_Pr1lfwvWkZh7OxuS2gi"
};
export default ___CSS_LOADER_EXPORT___;
